import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';

export function CTABanner() {
  return (
    <section className="bg-ledger-green py-14">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-4 text-center sm:flex-row sm:justify-between sm:text-left sm:px-6">
        <div>
          <h2 className="font-display text-2xl font-bold text-paper">Ready to get your paperwork filed?</h2>
          <p className="mt-1 text-paper/80">Book a 30-minute consultation and we'll take it from there.</p>
        </div>
        <Link to="/consult">
          <Button variant="accent" size="lg" className="whitespace-nowrap">
            Book a Consultation
          </Button>
        </Link>
      </div>
    </section>
  );
}
